import { render, staticRenderFns } from "./ProtocolDashboard.vue?vue&type=template&id=4115887b&scoped=true&"
import script from "./ProtocolDashboard.vue?vue&type=script&lang=js&"
export * from "./ProtocolDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ProtocolDashboard.vue?vue&type=style&index=0&id=4115887b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4115887b",
  null
  
)

export default component.exports